// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/bilateral_trade_product_type.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/bilateral_trade_product_type.proto.
 */
export const file_bfftypes_v1_bilateral_trade_product_type: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ0eXBlcy92MS9iaWxhdGVyYWxfdHJhZGVfcHJvZHVjdF90eXBlLnByb3RvEgtiZmZ0eXBlcy52MSrMAQoZQmlsYXRlcmFsVHJhZGVQcm9kdWN0VHlwZRIsCihCSUxBVEVSQUxfVFJBREVfUFJPRFVDVF9UWVBFX1VOU1BFQ0lGSUVEEAASKQolQklMQVRFUkFMX1RSQURFX1BST0RVQ1RfVFlQRV9TVEFOREFSRBABEicKI0JJTEFURVJBTF9UUkFERV9QUk9EVUNUX1RZUEVfU1BSRUFEEAISLQopQklMQVRFUkFMX1RSQURFX1BST0RVQ1RfVFlQRV9OT05fU1RBTkRBUkQQA0JCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * BilateralTradeProductType は相対取引の商品形態 (標準 / スプレッド / 非定型)。
 * Mirrors backend types.v1.BilateralTradeProductType 1:1 (wire 値も同一)。
 * 永続化されない導出値である点も同じ (= backend が保存状態から導出して返す)。
 *
 * @generated from enum bfftypes.v1.BilateralTradeProductType
 */
export enum BilateralTradeProductType {
  /**
   * @generated from enum value: BILATERAL_TRADE_PRODUCT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 標準 — 定型の時間帯・日区分を持つ通常契約 (1 取引 = 1 単位)。
   *
   * @generated from enum value: BILATERAL_TRADE_PRODUCT_TYPE_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * スプレッド — 売買逆の 2 取引を deal_id 共有でアトミック登録する契約。
   *
   * @generated from enum value: BILATERAL_TRADE_PRODUCT_TYPE_SPREAD = 2;
   */
  SPREAD = 2,

  /**
   * 非定型 — 日区分×時間帯区分の 1 パターンを 1 取引で表す契約。
   *
   * @generated from enum value: BILATERAL_TRADE_PRODUCT_TYPE_NON_STANDARD = 3;
   */
  NON_STANDARD = 3,
}

/**
 * Describes the enum bfftypes.v1.BilateralTradeProductType.
 */
export const BilateralTradeProductTypeSchema: GenEnum<BilateralTradeProductType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_bilateral_trade_product_type, 0);

